import { type ControllerRenderProps, useController } from 'react-hook-form';
import { isPastDate } from '@doxyme/ui/utils';
import { useFormRules } from '@doxyme/ui/hooks';
import { useIntl } from '@doxyme/locale';
import type {
  InviteViaEmailFormReturn,
  InviteViaEmailFormValues,
} from '../inviteViaEmailForm.types';

export const useDateField = (
  form: InviteViaEmailFormReturn,
): ControllerRenderProps<InviteViaEmailFormValues, 'dateField'> => {
  const { validateDate } = useFormRules();
  const { formatMessage } = useIntl();

  return useController({
    name: 'dateField',
    defaultValue: null,
    control: form.control,
    rules: {
      validate: {
        validateDate,
        validatePastDate: (date) => {
          if (date === null) {
            return true;
          }

          if (isPastDate(date)) {
            return formatMessage({ id: 'form.validation.dateInPast' });
          }

          return true;
        },
      },
    },
  }).field;
};
